// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
   to { transform: rotate(360deg); }
}

.spin {
  animation: spin .8s linear infinite;
}



 @keyframes gpCheck    { from{stroke-dashoffset:40} to{stroke-dashoffset:0} }

 .check{
   animation: gpCheck .3s ease forwards;
 }


  @keyframes gpCountUp { from{opacity:0;transform:scale(.7)} to{opacity:1;transform:scale(1)} }

  .countUp{
    animation: gpCountUp .5s ease both;
  }



  @keyframes gpPulseRing { 0%{transform:scale(1);opacity:.6} 100%{transform:scale(1.6);opacity:0} }

  @keyframes gpDotDance { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }

  @keyframes gpFadeIn   { from{opacity:0} to{opacity:1} }`, "",{"version":3,"sources":["webpack://./src/data/style/keyframes.css"],"names":[],"mappings":"AAAA;GACG,KAAK,yBAAyB,EAAE;AACnC;;AAEA;EACE,mCAAmC;AACrC;;;;CAIC,wBAAwB,KAAK,oBAAoB,EAAE,GAAG,mBAAmB,EAAE;;CAE3E;GACE,oCAAoC;CACtC;;;EAGC,uBAAuB,KAAK,SAAS,CAAC,mBAAmB,EAAE,GAAG,SAAS,CAAC,kBAAkB,EAAE;;EAE5F;IACE,kCAAkC;EACpC;;;;EAIA,yBAAyB,GAAG,kBAAkB,CAAC,UAAU,EAAE,KAAK,oBAAoB,CAAC,SAAS,EAAE;;EAEhG,wBAAwB,QAAQ,uBAAuB,EAAE,IAAI,0BAA0B,EAAE;;EAEzF,wBAAwB,KAAK,SAAS,EAAE,GAAG,SAAS,EAAE","sourcesContent":["@keyframes spin {\n   to { transform: rotate(360deg); }\n}\n\n.spin {\n  animation: spin .8s linear infinite;\n}\n\n\n\n @keyframes gpCheck    { from{stroke-dashoffset:40} to{stroke-dashoffset:0} }\n\n .check{\n   animation: gpCheck .3s ease forwards;\n }\n\n\n  @keyframes gpCountUp { from{opacity:0;transform:scale(.7)} to{opacity:1;transform:scale(1)} }\n\n  .countUp{\n    animation: gpCountUp .5s ease both;\n  }\n\n\n\n  @keyframes gpPulseRing { 0%{transform:scale(1);opacity:.6} 100%{transform:scale(1.6);opacity:0} }\n\n  @keyframes gpDotDance { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }\n\n  @keyframes gpFadeIn   { from{opacity:0} to{opacity:1} }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
